import React, { useState } from 'react';
import { Flex, Text, Box, Button, Image } from 'rebass';
import Wrapper from 'gift-certificate/Wrapper';
import GiftCertificateField from 'babys-first-year/GiftCertificateField';
import ProductPackagesListing from './ProductPackagesListing';
import BookMockUp from './assets/WMG-preview.png';
import Naapa from 'gift-certificate/assets/Naapa-award-winner.png';
import { BiHappyHeartEyes } from "react-icons/bi";
import store from 'store';
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

function PlanCard({ title, tryForFree, subtitle, priceHeadline, description, isSelected, onSelect }) {
    const doesItIncludeDollar = (priceHeadline || '').includes('$');
    let newHtml = priceHeadline
    if (newHtml) {
        newHtml = newHtml.replace(
            /\$(\d+)(\.\d+)?/,
            (_, dollars, cents) => `$${dollars}${cents ? `<sup>${cents}</sup>` : ''}`
        );
    }

    return <Box
        my={2}
        borderWidth="2px"
        borderColor={isSelected ? "#9B59B6" : "#0E0E0E"}
        cursor="pointer"
        sx={{
            cursor: 'pointer',
            borderRadius: "10px",
            border: `1px solid ${isSelected ? "#9B59B6" : 'rgba(100, 116, 139, 0.50)'}`,
            background: "white",
        }}
    >
        <Flex px={2} width={"100%"} py={"3px"} sx={{ bg: isSelected ? "#9B59B6" : 'white', borderRadius: '8px 8px 0px 0px', borderBottom: `1px solid ${isSelected ? '#9B59B6' : 'rgba(100, 116, 139, 0.50)'}` }}>
            <Flex justifyContent="center" alignItems="center" m="auto" px={2}>
                <Box as={BiHappyHeartEyes} minWidth={24} color={isSelected ? "#fff" : "#000000"} size={24} />
                <Text width={subtitle ? ["30%", "20%"] : "100%"} fontFamily="Poppins" fontWeight={500} lineHeight="150%" letterSpacing="-0.32px" pl="10px" color={isSelected ? "#fff" : "#0E0E0E"}>{title}</Text>
            </Flex>
        </Flex>

        <Flex p={2} justifyContent="space-between">
            <Flex flexDirection={!doesItIncludeDollar ? "row" : "column"}>
                <Text fontSize={!doesItIncludeDollar ? 30 : 16} textAlign="center" fontFamily="Poppins" fontWeight={400} lineHeight="150%" letterSpacing="-0.32px" color="#0E0E0E"
                    sx={{
                        'b': {
                            fontSize: 30,
                            fontWeight: '400 !important',
                            fontFamily: 'Bitter',
                            letterSpacing: '-0.6px',
                        }
                    }}
                    dangerouslySetInnerHTML={{ __html: newHtml }}
                />
                <Text mt="10px" ml={doesItIncludeDollar && 3} px={2} fontFamily="Poppins" fontWeight={400} lineHeight="150%" letterSpacing="-0.32px"
                    sx={{ 'div': { mb: "10px" } }}
                    dangerouslySetInnerHTML={{ __html: description.replaceAll('.', '.<div></div>') }}
                />
            </Flex>
        </Flex>
        <Flex my={2} sx={{ gap: 2 }} flexDirection="column" justifyContent="center" alignItems="center">
            <Button height="44px" width={285} py="unset" sx={{ borderRadius: '23px', }} onClick={onSelect} mx="auto" >Buy Now</Button>
            <Button variant="muted" width={285} height="44px" py="unset"
                sx={{ borderRadius: '23px', color: '#9B59B6', border: '1.5px solid #9B59B6' }}
                onClick={() => window.open('https://babyyearbooks.com/watch-me-grow', '_blank')}
                mx="auto" >Learn More</Button>
        </Flex>
    </Box >
}

const ReadyToPurchase = ({
    onStepUp,
    onStepDown,
    quantity,
    setRequiresQuantity,
    calculatedPricing,
    generateInvoice,
    orderSummary,
    firePostMemberEvent,
    member,
    email,
    redeemCode,
    setEmail,
    isForMyBaby,
    hideSkip,
    currentChildJournalId,
    nextButtonText,
    imageURL = Naapa,
    calculatedPricingWMG,
    setSelectedPlan,
    status,
    setStatus,
    ...props
}) => {
    const wmgPlan = calculatedPricingWMG?.allPackages?.paidPlans?.[0]
    const [showPaidPlans, setShowPaidPlans] = useState(false);

    return (<Wrapper
        hideSkip={hideSkip}
        onSubmit={status?.type === 'success' ? onStepUp : undefined}
        onBack={onStepDown}
        bg="aliceBlue"
        nextButtonText={nextButtonText}
    >
        <Flex justifyContent="center" alignItems="center">
            <Image maxWidth={480} src={imageURL} />
        </Flex>
        <Box m="auto" mt="2.7%" width={['92%', '92%', '480px']} minWidth={['max-width', 480]}>
            <ProductPackagesListing
                currentChildJournalId={currentChildJournalId}
                isForMyBaby={isForMyBaby}
                onStepUp={onStepUp}
                setSelectedPlan={setSelectedPlan}
                {...props}
            />

            {isForMyBaby && !props?.isFromRedeemCertificate && <GiftCertificateField status={status} setStatus={setStatus}  {...props} />}

        </Box>
        <Box bg="#F2F8FF" p={2} pt={3} mt={3}>
            <Flex alignItems="center" justifyContent="center" my={2}  >
                <Text fontFamily="Bitter" textAlign="center" width="max-content" fontSize="30px" lineHeight="120%" letterSpacing="-0.18px" color="#0E0E0E">
                    Want to start with something easier than a book?
                </Text>
            </Flex>
            <Flex alignItems="center" justifyContent="center" my={1} onClick={() => setShowPaidPlans(!showPaidPlans)} sx={{ cursor: 'pointer', width: 'max-content', m: 'auto' }} >
                <Text px={1} fontFamily="Poppins" fontSize="16px" lineHeight="150%" fontWeight={600} letterSpacing="-0.32px" color="#2072CB">
                    Check out Watch Me Grow!
                </Text>
                <Text size={16} width={20} mb="-3px" ml={1} as={showPaidPlans ? FaChevronUp : FaChevronDown} color="#2072CB" />
            </Flex>
            {showPaidPlans && <Box>
                <Text my="30px" fontFamily="Poppins" textAlign="center" fontSize="16px" lineHeight="150%" letterSpacing="-0.096px" color="#0E0E0E">
                    Effortlessly create a monthly video montage
                    and beautiful collage print
                </Text>
                <Box maxWidth={480} mx="auto" >
                    <Image src={BookMockUp} />
                </Box>
                <Box maxWidth={480} mx="auto" >
                    {wmgPlan && <PlanCard {...wmgPlan} onSelect={() => {
                        setSelectedPlan(wmgPlan)
                        onStepUp(wmgPlan)
                        store.set('selectedPackageId', wmgPlan?.id)
                    }} />}
                </Box>
            </Box>}
        </Box>
    </Wrapper>
    );
};

export default ReadyToPurchase;
